export const dictionary_ES = {
  mensajeInicial:
    "Esta aplicación ha sido desarrollada por el equipo investigador de la Cátedra Avenzoar de la Universidad de Sevilla y el Colegio Oficial de Farmacéuticos. A través de las respuestas de 10 preguntas de tipo general se pretende dar información sobre educación sanitaria para prevenir un posible contagio por COVID-19.",
  calcular: "CALCULAR",
  comparte: "Comparte",
  rankText1:
    "Estás corriendo un riesgo importante tanto a nivel individual como colectivo y debes replantearte un cambio en tu actitud.",
  rankText2:
    "Tienes algunas conductas que deberías mejorar para evitar riesgos, tanto a nivel individual, como colectivo.",
  rankText3:
    "¡Enhorabuena! Estás manteniendo unos hábitos de conducta adecuados.",
  errorMsg: "Debes contestar todas las preguntas para obtener el resultado.",
  resultadosGlobales: "Resultados Globales:",
  todo: "Todo (Desde 16 Marzo 2021)",
  months3: "Últimos 3 Meses",
  lastmonth: "Último Mes",
  days15: "Últimos 15 Días",
};

export const dictionary_EN = {
  mensajeInicial:
    "This application has been developed by Cátedra Avenzoar de la Universidad de Sevilla and Colegio Oficial de Farmacéuticos research teams. By answering 10 general purpose questions, the main aim is providing information about health education in order to avoid possible COVID-19 infections.",
  calcular: "CALCULATE",
  comparte: "Share",
  rankText1:
    "You are taking a significant risk both individually and collectively, and you must rethink a change in your attitude.",
  rankText2:
    "You have some behaviors that you should improve to avoid risks, both individually and collectively.",
  rankText3: "Congratulations! You are maintaining proper behavior habits.",
  errorMsg: "You must answer all the questions to get the result.",
  resultadosGlobales: "Global Results:",
  todo: "All (From 16th March 2021)",
  months3: "Last 3 Months",
  lastmonth: "Last Month",
  days15: "Last 15 Days",
};

export const dictionary_PT = {
  mensajeInicial:
    "Este aplicativo foi desenvolvido pelas equipes de pesquisa Cátedra Avenzoar de la Universidad de Sevilla e Colegio Oficial de Farmacéuticos. Ao responder a 10 perguntas de propósito geral, o principal objetivo é fornecer informações sobre educação em saúde, a fim de evitar possíveis infecções por COVID-19.",
  calcular: "CALCULAR",
  comparte: "Compartilhar",
  rankText1:
    "Você está assumindo um risco significativo, individual e coletivamente, e deve repensar uma mudança de atitude.",
  rankText2:
    "Você tem alguns comportamentos que deve melhorar para evitar riscos, individualmente e coletivamente.",
  rankText3: "Parabéns! Você está mantendo hábitos de comportamento adequados.",
  errorMsg: "Você deve responder a todas as perguntas para obter o resultado.",
  resultadosGlobales: "Resultados Globais:",
  todo: "Todo (De 16 de março de 2021)",
  months3: "Últimos 3 Meses",
  lastmonth: "Mês passado",
  days15: "Últimos 15 dias",
};

export const dictionary_DE = {
  mensajeInicial:
    "Diese Anwendung wurde von Cátedra Avenzoar de la Universidad de Sevilla- und Colegio Oficial de Farmacéuticos-Forschungsteams entwickelt. Durch die Beantwortung von 10 allgemeinen Fragen besteht das Hauptziel darin, Informationen zur Gesundheitserziehung bereitzustellen, um mögliche COVID-19-Infektionen zu vermeiden.",
  calcular: "BERECHNUNG",
  comparte: "Aktie",
  rankText1:
    "Sie gehen sowohl einzeln als auch gemeinsam ein erhebliches Risiko ein und müssen eine Änderung Ihrer Einstellung überdenken.",
  rankText2:
    "Sie haben einige Verhaltensweisen, die Sie verbessern sollten, um Risiken sowohl einzeln als auch gemeinsam zu vermeiden.",
  rankText3:
    "Herzliche Glückwünsche! Sie pflegen die richtigen Verhaltensgewohnheiten.",
  errorMsg: "Sie müssen alle Fragen beantworten, um das Ergebnis zu erhalten.",
  resultadosGlobales: "Globale Ergebnisse:",
  todo: "Alle (Ab dem 16. März 2021)",
  months3: "Letzte 3 Monate",
  lastmonth: "Letzten Monat",
  days15: "Letzte 15 Tage",
};

export const dictionary_FR = {
  mensajeInicial:
    "Cette application a été développée par les équipes de recherche Cátedra Avenzoar de la Universidad de Sevilla et Colegio Oficial de Farmacéuticos. En répondant à 10 questions d'ordre général, l'objectif principal est de fournir des informations sur l'éducation sanitaire afin d'éviter d'éventuelles infections au COVID-19.",
  calcular: "CALCULER",
  comparte: "Partager",
  rankText1:
    "Vous prenez un risque important à la fois individuellement et collectivement, et vous devez repenser un changement d'attitude.",
  rankText2:
    "Vous devez améliorer certains comportements pour éviter les risques, à la fois individuellement et collectivement.",
  rankText3:
    "Toutes nos félicitations! Vous maintenez de bonnes habitudes de comportement.",
  errorMsg:
    "Vous devez répondre à toutes les questions pour obtenir le résultat.",
  resultadosGlobales: "Résultats Globaux:",
  todo: "Tout (À partir du 16 mars 2021)",
  months3: "3 Derniers Mois",
  lastmonth: "Le Mois Dernier",
  days15: "15 Derniers Jours",
};

export const dictionary_IT = {
  mensajeInicial:
    "Questa applicazione è stata sviluppata dai team di ricerca Cátedra Avenzoar de la Universidad de Sevilla e Colegio Oficial de Farmacéuticos. Rispondendo a 10 domande di carattere generale, l'obiettivo principale è quello di fornire informazioni sull'educazione sanitaria al fine di evitare possibili infezioni da COVID-19.",
  calcular: "CALCOLARE",
  comparte: "Condividere",
  rankText1:
    "Stai correndo un rischio significativo sia individualmente che collettivamente e devi ripensare un cambiamento nel tuo atteggiamento.",
  rankText2:
    "Hai alcuni comportamenti che dovresti migliorare per evitare rischi, sia individualmente che collettivamente.",
  rankText3:
    "Congratulazioni! Stai mantenendo le giuste abitudini comportamentali.",
  errorMsg:
    "È necessario rispondere a tutte le domande per ottenere il risultato.",
  resultadosGlobales: "Risultati Globali:",
  todo: "Tutti (Dal 16 marzo 2021)",
  months3: "Ultimi 3 Mesi",
  lastmonth: "Lo Scorso Mese",
  days15: "Ultimi 15 Giorni",
};
